// extracted by mini-css-extract-plugin
export default {"mainContainer":"CenterPart_mainContainer__j6jwT","leftCol":"CenterPart_leftCol__ZEaqb","fontSize":"CenterPart_fontSize__PAaMc","title":"CenterPart_title__8P3qk"};